import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent {
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() showText: boolean = true;

  get iconSize(): number {
    switch (this.size) {
      case 'small': return 24;
      case 'large': return 48;
      default: return 32;
    }
  }
} 